<div class="classification">
    <div class="classification__label">{{ 'COMPONENT.classification.label' | translate }}</div>
    <div class="classification__value">{{ 'COMPONENT.classification.value' | translate }}</div>
</div>
